import { useFetch } from '@chipinside/fetcher'
import { FeedBackLevel } from '@chipinside/formbuilder'
import { LoadingIconButton } from '@chipinside/frontend'
import { Translate } from '@chipinside/translate'
import { isNil } from 'lodash'
import { Link } from 'react-router-dom'

import CowmedChip from '#/components/Chip'
import { Icon } from '#/components/Icon'
import { useFarm, useFarmSlug } from '#/store/ducks/farm'
import { usePermissions } from '#/store/ducks/permissions'
import { endpoint } from '#/store/services/endpoints'
import Colors from '#/styles/Colors'
import { isBusinessEnvironment } from '#/utils'
import { getLink } from '#/utils/getLink'

type TypeFarmCoverageProps = {
  value: {
    level: FeedBackLevel
    value: string
    variant: 'icon' | 'chip'
  }
  farm?: string
}

export const TypeFarmCoverage = (props: TypeFarmCoverageProps) => {
  const { farm: farmSlug, value } = props

  const permissions = usePermissions()

  const farm = useFarm()

  if (isNil(value)) return null

  const { level, variant } = value

  // Se a fazenda for cow-connect por não ter dados de conectividade não renderiza
  if (farm?.plan?.slug === 'cow-connect') return null

  // Se for ambiente system renderiza, se for ambiente farm verifica permissão
  if (!isBusinessEnvironment() && !permissions.farm.view_farm_connectivity) return null

  const variants = {
    chip: <CowmedChip value={value.value} style={Colors.feedback[level]} />,
    icon: <CComIcon farm={farmSlug} level={level} value={value?.value} />,
  }

  return variants[variant]
}

const REFRESH_INTERVAL = 10 * 60 * 1000 // 10 minutos

type CComIconProps = {
  level: FeedBackLevel
  farm?: string
  value?: string
}

const CComIcon = (props: CComIconProps) => {
  let { farm, level, value } = props

  if (!farm) {
    farm = useFarmSlug()
  }

  // Caso não tenha informações busca através do endpoint de status da fazenda
  const controller = !value && farm ? endpoint.farm.status({ farm }) : null

  const { data, isLoading } = useFetch<any>({
    controller,
    swrOptions: { refreshInterval: REFRESH_INTERVAL },
  })

  /* Se não tiver dados ou o valor for nulo, não renderiza nada
   * evita problemas de renderização com dados incompletos
   */
  if (!data && !value) return null

  if (data?.level) {
    level = data.level
  }

  const color = Colors.feedback[level]?.color

  const iconTypes = {
    error: 'disconnected',
    success: 'connected',
    warning: 'partially-disconnected',
  }

  const iconType = iconTypes[level]

  const icon = iconType ? <Icon name={iconType} size="medium" color={color} /> : undefined

  const link = getLink({ id: 'farm-monitoring-c-com', params: farm ? { farm } : undefined })

  if (!link) return icon

  return (
    <LoadingIconButton
      component={Link}
      // @ts-ignore
      to={link}
      target="_blank"
      title={Translate({ messageKey: 'open_c_com_managment' })}
      loading={isLoading}
      icon={icon}
      size="large"
    />
  )
}
